import React from "react";
import { Link } from "react-router-dom";
import { Heart, ShoppingBag, Trash2 } from "lucide-react";
import { useWishlist } from "@/contexts/WishlistContext";
import { useCart } from "@/contexts/CartContext";
import { formatPrice, productUrl } from "@/lib/storefront";

export default function Wishlist() {
  const { items, remove } = useWishlist();
  const { addItem } = useCart();

  return (
    <div className="mx-auto max-w-[1440px] px-6 py-14 md:px-10 md:py-20" data-testid="wishlist-page">
      <div className="mb-10 text-xs uppercase tracking-[0.25em] text-[#6B5158]">
        <Link to="/" className="hover:text-[#2B2127]">Home</Link>
        <span className="mx-2">/</span>
        <span>Wishlist</span>
      </div>
      <h1 className="font-display text-5xl md:text-[72px]">
        Your <span className="font-display-soft">wishlist</span>
      </h1>

      {items.length === 0 ? (
        <div className="mt-14 py-14 text-center">
          <Heart size={56} strokeWidth={1.2} className="mx-auto mb-6 text-[#6B5158]/30" />
          <h2 className="font-display text-3xl">Nothing saved yet</h2>
          <p className="mt-2 text-sm text-[#6B5158]">Tap the heart on any product to save it here.</p>
          <Link to="/catalog" className="mt-8 inline-flex rounded-full bg-[#2B2127] px-8 py-3.5 text-sm text-white hover:bg-[#9D5C6C]">Explore the shop</Link>
        </div>
      ) : (
        <div className="mt-12 grid grid-cols-2 gap-x-4 gap-y-10 md:grid-cols-3 lg:grid-cols-4">
          {items.map((p) => (
            <div key={p.id} className="group relative" data-testid={`wish-${p.id}`}>
              <Link to={productUrl(p)} className="block">
                <div className="aspect-[4/5] overflow-hidden rounded-sm bg-[#F1E3DC]">
                  {p.image && <img src={p.image} alt="" className="h-full w-full object-cover" />}
                </div>
                <div className="pt-3">
                  <h3 className="font-display text-base">{p.title}</h3>
                  <div className="mt-1 text-sm store-nums">{formatPrice(p.price, p.currency)}</div>
                </div>
              </Link>
              <div className="mt-3 flex gap-2">
                <button onClick={() => addItem(p, 1)} className="flex-1 rounded-full bg-[#2B2127] px-3 py-2 text-xs text-white hover:bg-[#9D5C6C]">
                  <ShoppingBag size={12} className="mr-1 inline-block" /> Add
                </button>
                <button onClick={() => remove(p.id)} className="rounded-full border border-[#E6D4CC] p-2 text-[#6B5158] hover:text-[#2B2127]"><Trash2 size={14} /></button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
